<template>
    <SoliAvatarBtn
        v-if="teacher"
        :outlined="outlined"
        @click="[$emit('input', teacher), (dialog = true)]"
        :avatar="teacher.profile_photo_url"
        :title="teacher.name"
        :blueShadow="!blueBorder"
        :blue="blueBorder"
        :size="size"
        :moreInfo="!!(expand && teacher.bio)"
        :disabled="disabled"
        :subtitleBottom="`${teacher.pronouns ? teacher.pronouns + ' | ' : ''}${
            teacher.instruments.length > 3
                ? teacher.instruments
                      .filter((e, idx) => 3 > idx)
                      .map((i) => ' ' + i.name) + '...'
                : teacher.instruments.map((i) => ' ' + i.name)
        }`"
        style="width: -webkit-fill-available; overflow: hidden"
    >
        <template>
            <SoliTeacherCert
                v-if="teacher.certification_level"
                :teacher="teacher"
        /></template>

        <TeacherInfo
            v-if="selectedInstrument"
            v-model="dialog"
            @close="dialog = false"
            :teacher="teacher"
            :selectedInstrument="selectedInstrument"
        ></TeacherInfo>
    </SoliAvatarBtn>
</template>

<script>
import TeacherInfo from "../Teachers/TeacherInfo.vue";

export default {
    components: {
        TeacherInfo,
    },
    props: {
        teacher: {
            type: Object,
            default: () => {},
        },
        expand: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        selectedInstrument: {
            type: Number,
            default: null,
        },
        outlined: {
            type: Boolean,
            default: true,
        },
        blueBorder: {
            type: Boolean,
            default: false,
        },
        size: {
            type: [Number, String],
            default: 64,
        },
    },
    data() {
        return {
            //expanded: null,
            dialog: false,
        };
    },
    methods: {
        /*getBio() {
            return axios
                .get(`/api/teacher-info/${this.teacher.id}/bio`)
                .then((resp) => {
                    console.log(resp.data);
                    return JSON.stringify(resp.data);
                });
        },*/
    },
};
</script>
